// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Status-badge_badge__FhNUA {
  display: flex;
  align-items: flex-start;
  padding: 2px 8px 2px 10px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: #e9f0f3;
  width: -moz-fit-content;
  width: fit-content;
/* z-index: 100; */
  color: #678aa1;
  text-align: center;
  font-family: Inter;
  font-size: 16px;
  white-space: nowrap;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.Status-badge_badge-active__PUYFk {
  background: #eaf8ef;
  color: #30bb67;
}

.Status-badge_badge-test__Tk\\+hR {
  background: #fff5e2;
  color: #ffa722;
  
}

.Status-badge_badge-error__icd-j {
  background: #fde7e7;
  color: #d83a3a;
}  

.Status-badge_badge-processing__GsqQL{
  background: #e3e8f3;
  color: #0e4350;
}

.Status-badge_circle__tM-F3 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 2px;
  background-color: #678aa1;
}

.Status-badge_circle-error__oQljm {
  background-color: #d83a3a;
}

.Status-badge_circle-active__kxu-E {
  background-color: #30bb67;
}

.Status-badge_circle-test__VCtWM {
  background-color: #ffa722;
}

.Status-badge_my-custom-span__iQu3P {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: #364954;
  border: 1px solid #364954;
  border-radius: 10px;
  padding: 8px;
}

.Status-badge_my-custom-span-disabled__mmQeM {
  color: #8598a3;
  border: 1px solid #8598a3;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/shared/Ui/StatusBadge/Status-badge.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,uBAAkB;EAAlB,kBAAkB;AACpB,kBAAkB;EAChB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;;AAEhB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,oBAAoB;AACtB","sourcesContent":[".badge {\n  display: flex;\n  align-items: flex-start;\n  padding: 2px 8px 2px 10px;\n  justify-content: center;\n  align-items: center;\n  gap: 6px;\n  border-radius: 6px;\n  background: #e9f0f3;\n  width: fit-content;\n/* z-index: 100; */\n  color: #678aa1;\n  text-align: center;\n  font-family: Inter;\n  font-size: 16px;\n  white-space: nowrap;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.badge-active {\n  background: #eaf8ef;\n  color: #30bb67;\n}\n\n.badge-test {\n  background: #fff5e2;\n  color: #ffa722;\n  \n}\n\n.badge-error {\n  background: #fde7e7;\n  color: #d83a3a;\n}  \n\n.badge-processing{\n  background: #e3e8f3;\n  color: #0e4350;\n}\n\n.circle {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 2px;\n  background-color: #678aa1;\n}\n\n.circle-error {\n  background-color: #d83a3a;\n}\n\n.circle-active {\n  background-color: #30bb67;\n}\n\n.circle-test {\n  background-color: #ffa722;\n}\n\n.my-custom-span {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 18px;\n  text-align: center;\n  color: #364954;\n  border: 1px solid #364954;\n  border-radius: 10px;\n  padding: 8px;\n}\n\n.my-custom-span-disabled {\n  color: #8598a3;\n  border: 1px solid #8598a3;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `Status-badge_badge__FhNUA`,
	"badge-active": `Status-badge_badge-active__PUYFk`,
	"badge-test": `Status-badge_badge-test__Tk+hR`,
	"badge-error": `Status-badge_badge-error__icd-j`,
	"badge-processing": `Status-badge_badge-processing__GsqQL`,
	"circle": `Status-badge_circle__tM-F3`,
	"circle-error": `Status-badge_circle-error__oQljm`,
	"circle-active": `Status-badge_circle-active__kxu-E`,
	"circle-test": `Status-badge_circle-test__VCtWM`,
	"my-custom-span": `Status-badge_my-custom-span__iQu3P`,
	"my-custom-span-disabled": `Status-badge_my-custom-span-disabled__mmQeM`
};
export default ___CSS_LOADER_EXPORT___;
